import {RoomSettingConstants} from '@colonist/game-base-types'
import {socket} from '../EntryShared.ts'
import {UIRoomCenterSettingsMaxPlayersView} from './UIRoomCenterSettingsMaxPlayersView.ts'
import {GameModeDataController} from '@colonist/shared-types'
import {RoomClientState} from '../RoomClientState.ts'
import {setElementOnClick} from '../ui_utils/DomUtils.ts'

export class UIRoomCenterSettingsMaxPlayersController {
    private readonly minPlayerCount: number
    private gameModeMaxPlayerCount: number
    private currentMaxPlayerCount: number

    private readonly view: UIRoomCenterSettingsMaxPlayersView

    constructor(container: HTMLDivElement) {
        this.minPlayerCount = RoomSettingConstants.MIN_PLAYER_COUNT
        this.gameModeMaxPlayerCount = RoomSettingConstants.MAX_PLAYER_COUNT
        this.currentMaxPlayerCount = RoomSettingConstants.DEFAULT_PLAYER_COUNT

        this.view = new UIRoomCenterSettingsMaxPlayersView(container)
    }

    update(newRoomState: RoomClientState) {
        this.currentMaxPlayerCount = newRoomState.gameSetting.maxPlayers

        const defaultPlayerCount = GameModeDataController.getModeDataForMode(newRoomState.gameSetting.modeSetting)?.defaultPlayerCount ?? RoomSettingConstants.DEFAULT_PLAYER_COUNT
        const gameModeMaxPlayerCount = GameModeDataController.getMaxAllowablePlayerCountForMode(newRoomState.gameSetting.modeSetting)

        this.view.setMaxPlayerCount(this.currentMaxPlayerCount, gameModeMaxPlayerCount)

        this.view.container.classList.toggle('selected', this.currentMaxPlayerCount != defaultPlayerCount)
    }

    load(roomState: RoomClientState) {
        this.initSpeedSettings(roomState)
    }

    private initSpeedSettings(roomState: RoomClientState) {
        const {
            maxPlayersDivBody: footerDiv,
            maxPlayersRightArrow: rightArrow,
            maxPlayersLeftArrow: leftArrow,
        } = this.view

        this.gameModeMaxPlayerCount = GameModeDataController.getMaxAllowablePlayerCountForMode(roomState.gameSetting.modeSetting)
        this.view.setMaxPlayerCount(this.currentMaxPlayerCount, this.gameModeMaxPlayerCount)

        const isMinPossiblePlayers = this.currentMaxPlayerCount == this.minPlayerCount
        const isMaxPossiblePlayers = this.currentMaxPlayerCount == this.gameModeMaxPlayerCount
        leftArrow.classList.toggle('disabled', isMinPossiblePlayers)
        rightArrow.classList.toggle('disabled', isMaxPossiblePlayers)

        if(UIRoomCenterSettingsMaxPlayersController.isGuest(roomState)) {
            footerDiv.className = 'option_body guest'
            rightArrow.classList.toggle('hidden', true)
            leftArrow.classList.toggle('hidden', true)
            setElementOnClick(rightArrow, () => undefined)
            setElementOnClick(leftArrow, () => undefined)
            return
        }
        footerDiv.className = 'option_body'
        rightArrow.classList.toggle('hidden', false)
        leftArrow.classList.toggle('hidden', false)
        setElementOnClick(rightArrow, () => {
            if(this.currentMaxPlayerCount >= this.gameModeMaxPlayerCount) return
            socket.roomClient.setMaxPlayers(this.currentMaxPlayerCount + 1)
        })

        setElementOnClick(leftArrow, () => {
            if(this.currentMaxPlayerCount <= this.minPlayerCount) return
            socket.roomClient.setMaxPlayers(this.currentMaxPlayerCount - 1)
        })
    }

    updateInteractabilityOfElements(roomState: RoomClientState) {
        this.load(roomState)
    }

    private static isGuest(roomState: RoomClientState): boolean {
        return socket.controller.session.id != roomState.hostSession.userSessionId
    }
}
